import React from 'react'
import { Link } from 'react-router-dom'

import { AppLayout, LanguageSelector } from '@/components'
import { useApp } from '@/hooks'

import notFound from '@/assets/images/404.png'

const NotFoundPage: React.FC = () => {
  const { me } = useApp()

  return (
    <AppLayout
      hasFooter={!!me}
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <div className="page-content">
        <div className="container">
          <div className="data-wrap centered">
            <div className="content-box">
              <div className="not-found">
                <div className="img">
                  <img src={notFound} alt="" />
                </div>
                <div className="info">
                  <h1>Ooops !</h1>
                  <p>Page not found.</p>
                  <Link to="/" className="main-btn">
                    Back to home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default NotFoundPage
